import { Button, CircularProgress } from "@mui/material";
import { graphql } from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";
import { InternTempoConnectButtonMutation } from "./__generated__/InternTempoConnectButtonMutation.graphql";

const mutation = graphql`
  mutation InternTempoConnectButtonMutation($brandId: ID!) {
    createTempoPartnerLink(brandId: $brandId) {
      id
      tempoApiToken
    }
  }
`;

type Props = {
  brandId: string;
};

const InternTempoConnectButton = ({ brandId }: Props) => {
  const [createTempoPartnerLink, isSaving] =
    useMutation<InternTempoConnectButtonMutation>(mutation);
  const onSubmit = () => {
    createTempoPartnerLink({
      variables: {
        brandId,
      },
    });
  };

  return (
    <Button
      onClick={onSubmit}
      variant="contained"
      disabled={isSaving}
      startIcon={isSaving ? <CircularProgress size={20} /> : null}
    >
      {isSaving ? "Connecting..." : "Connect"}
    </Button>
  );
};

export default InternTempoConnectButton;
